import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removePartialTypeString'
})
export class RemovePartialTypeStringPipe implements PipeTransform {
    transform(objects: any[], partialObjectString: string[]): any {
        if (objects == null) return;

        if (partialObjectString == null) return objects;

        var out = [];
        for (var i = 0; i < objects.length; i++) {
            if (out.indexOf(objects[i]) == -1) {
                out.push(objects[i]);
            }
            if (objects[i].TYPE.indexOf(partialObjectString) >= 0) {
                out.splice(out.length - 1, 1);
            }
        }

        return out;
    }
}
